import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { StorageService } from '../services/storage.service';

export const trackingIdGuard: CanActivateFn = route => {
  const storage = inject(StorageService);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) return of(true);
  if (route.queryParams._cio_id) {
    storage.set('_cio_id', route.queryParams._cio_id, true);
  }
  return of(true);
};
